package it.unibo.tuprolog.solve.stdlib.rule

import it.unibo.tuprolog.core.Scope
import it.unibo.tuprolog.core.Term
import it.unibo.tuprolog.solve.ExecutionContext
import it.unibo.tuprolog.solve.rule.RuleWrapper
import it.unibo.tuprolog.solve.stdlib.primitive.EnsureExecutable
import kotlin.collections.List as KtList
import kotlin.collections.listOf as ktListOf

object Not : RuleWrapper<ExecutionContext>("not", 1) {
    override val help: String =
        """
        `not(+Goal)`
        
        Calls `Goal` under negation as failure. It succeeds when `Goal` has no solution and fails when `Goal` succeeds. `Goal` must be executable.

        **Examples**

        ```prolog
        ?- not(member(d, [a, b, c])).
        yes.

        ?- not(X = 1).
        no.

        ?- not(X).
        throws error(instantiation_error, _).
        ```
        """.trimIndent()

    override val Scope.head: KtList<Term>
        get() = ktListOf(varOf("G"))

    override val Scope.body: Term
        get() =
            tupleOf(
                structOf(EnsureExecutable.functor, varOf("G")),
                structOf("\\+", varOf("G")),
            )
}
